// @ts-strict-ignore
/* eslint-disable import/no-anonymous-default-export */
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { ButtonLink } from './button-link-element'
import { gtmTrack } from '../utils/tracking'
import { timeout, useComponentTracking } from '../utils/component-events'

export default ({ text, href, link, ...props }) => {
  const hrefLink = href || link
  const { id, name, variant, size } = props
  const trackComponent = useComponentTracking()

  const onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    gtmTrack('GA Button Clicked', 'Functional Interaction', `${text}`)
    timeout(trackComponent('Dynamic Component Event', 'CTAButtonClicked', { text })).then(() => {
      window.location.href = hrefLink
    })
  }

  return (
    <ButtonLink
      href={hrefLink}
      onClick={(e) => onClick(e)}
      size={size}
      id={id}
      name={name}
      variant={variant}
      {...props}
    >
      {text}
    </ButtonLink>
  )
}
